import { render, staticRenderFns } from "./Brewing.vue?vue&type=template&id=e544772c&lang=pug&"
import script from "./Brewing.vue?vue&type=script&lang=js&"
export * from "./Brewing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports